export default {
  styling: {
    drawers: {
      drawerOpenSpacing: 30,
      drawerClosedSpacing: 8,
    },
  },
};
